import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import { AddFolderButton, SmallScreenModel } from "components";
import BreadcrumbFolderLayout from "../components/BreadcrumbFolderLayout";
import GroupCard from "./page/component/GroupCard";
import CreateGroup from "./page/CreateGroup";
import { fetchVideoGroups } from "./store/action";
import { VideoGroupProps } from "./store/actionType";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Group: React.FC<Props> = ({ onFetchVideoGroups, videoGroupState }) => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSectionClick = async (groupId: string) => {
    navigate(`/video/${groupId}`);
  };

  useEffect(() => {
    onFetchVideoGroups();
  }, [onFetchVideoGroups]);
  const breadcrumbItem = [{ group: "Group", root: "Root" }];
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_GROUP));
  return (
    <div className="h-full overflow-hidden">
      {videoGroupState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={videoGroupState?.groups}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Create Group
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {videoGroupState?.groups &&
                videoGroupState?.groups?.map((groupData: VideoGroupProps) => (
                  <GroupCard
                    key={groupData.id || groupData.name}
                    groupData={groupData}
                    onClick={() => handleSectionClick(groupData.id)}
                  />
                ))}
            </div>
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateGroup closeModal={closeModal} />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  videoGroupState: state.videoGroups?.videoGroupsState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoGroups: () => dispatch(fetchVideoGroups()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Group);
